import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const breastFeedingListApi = async (data) => {
  const endPoint = `admin/breast-feeding/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
